import { render, staticRenderFns } from "./Retencoes.vue?vue&type=template&id=1cf4f006&scoped=true"
import script from "./Retencoes.vue?vue&type=script&lang=js"
export * from "./Retencoes.vue?vue&type=script&lang=js"
import style0 from "./Retencoes.vue?vue&type=style&index=0&id=1cf4f006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf4f006",
  null
  
)

export default component.exports